/**
 * Based on the response it throws the appropriate error
 * @param response
 */
export const throwResponseError = response => {
    let errMssg;
    if (response) {
        errMssg =
            response.MessageText ||
            `Service call failed with response code: ${response.ResponseCode}`;
    } else {
        errMssg = 'response is null';
    }
    throw new Error(errMssg);
};
